import { Socket, io } from 'socket.io-client';

import { DefaultEventsMap } from '@socket.io/component-emitter';
import { config } from '~/config';

export enum Event {
  MessageStatus = 'message-status',
  MessageCreated = 'message-created',
  MessageRemoved = 'message-removed',
}

export class EventsGateway {
  private socket: Socket<DefaultEventsMap, DefaultEventsMap>;

  constructor() {
    this.socket = io(config.socketUrl);
  }

  subscribe(event: Event, handler: (payload: any) => void) {
    this.socket.on(event, handler);
  }

  unSubscribe(event: Event, handler: (payload: any) => void) {
    this.socket.off(event, handler);
  }
}

const eventsGateway = new EventsGateway();

export const useEvents = () => eventsGateway;
